import { useEffect, useState } from 'react';
import home_icon from '../../../assets/home_icon.svg';
import bed_icon from '../../../assets/bed_icon.svg';
import bath_icon from '../../../assets/bath_icon.svg';
import location_icon from '../../../assets/location_icon.svg';
import people_icon from '../../../assets/people_icon.svg';
import {
  AddPropertyBtn,
  Container,
  Header,
  Title,
  Row,
  Card,
  PropertyImage,
  PropertyDescription,
  PropertyDetails,
  PropertyHeader,
  PropertyName,
  PropertyPrice,
  Icon,
  IconContainer,
  IconRow,
  IconTitle,
  PropertyDescriptionHeader,
  PropertyAddress,
  PropertyAddressDetails,
  PropertyInspections,
  PropertyLocation,
  Symbol,
  PropertyInspectionDetails,
  InspectionPrice,
  CustomAgentCard
} from './style';
import { EditProperty } from '../allProperties/component/propertyModals/editProperty';
import { useLocation } from 'react-router-dom';
import { IProperty } from '../../../store/realEstate/interface';
import { useGetOnePropertiesQuery } from '../../../store/realEstate/api';
import { Loader } from '../../../component/loader';
import { currencyFormatter } from '../../../utils/currencyConverter';

export const ViewProperty = () => {
  const [editPropertyModal, setEditPropertyModal] = useState(false);
  const handleEditProperty = () => {
    setEditPropertyModal(true);
  };

  const { state } = useLocation();
  const [propertyId] = useState((state as { propertyId: string }).propertyId);
  const [propertyItem, setpropertyItem] = useState<IProperty>();

  const { data: viewOneProperty, isLoading: isviewOnePropertyLoading } =
    useGetOnePropertiesQuery(propertyId);

  useEffect(() => {
    if (viewOneProperty) {
      setpropertyItem(viewOneProperty.data);
    }
  }, [viewOneProperty]);
  return (
    <Container>
      {isviewOnePropertyLoading && <Loader />}
      {editPropertyModal && (
        <EditProperty
          setShow={setEditPropertyModal}
          propertyItems={propertyItem}
        />
      )}
      <Header>
        <Title>{`${propertyItem?.category} properties`}</Title>
        <AddPropertyBtn onClick={() => handleEditProperty()}>
          Edit property
        </AddPropertyBtn>
      </Header>
      <Row>
        <Card>
          <PropertyImage images={propertyItem?.file ?? []} />
          <PropertyDetails>
            <PropertyHeader>
              <PropertyName>{propertyItem?.title}</PropertyName>
              <PropertyPrice>{`N${currencyFormatter(
                propertyItem?.price ?? ''
              )}${
                propertyItem?.category !== 'buy' ? '/yr' : ''
              }`}</PropertyPrice>
            </PropertyHeader>
            <PropertyHeader>
              <PropertyInspectionDetails>
                <InspectionPrice>
                  N{propertyItem?.inspectionFee ?? 0}
                </InspectionPrice>
                <PropertyHeader>
                  <Symbol src={location_icon} />
                  <PropertyLocation>
                    {`${propertyItem?.location?.state}, Nigeria`}
                  </PropertyLocation>
                </PropertyHeader>
              </PropertyInspectionDetails>
              <PropertyHeader>
                <Symbol src={people_icon} />
                <PropertyInspections>{`${
                  propertyItem?.noOfInspections ?? 0
                } Inspections`}</PropertyInspections>
              </PropertyHeader>
            </PropertyHeader>
            <IconRow>
              <IconContainer>
                <Icon src={bed_icon} />
                <IconTitle>{`${propertyItem?.noOfRooms} Rooms`}</IconTitle>
              </IconContainer>
              <IconContainer>
                <Icon src={bath_icon} />
                <IconTitle>{`${propertyItem?.noOfBath} Baths`}</IconTitle>
              </IconContainer>
              <IconContainer>
                <Icon src={home_icon} />
                <IconTitle>{`${
                  propertyItem?.type === 'land'
                    ? `${propertyItem.landSize.value} ${propertyItem.landSize.unit}`
                    : `${propertyItem?.roomSize} Sqm`
                }`}</IconTitle>
              </IconContainer>
            </IconRow>
            <PropertyAddress>Address</PropertyAddress>
            <PropertyAddressDetails>
              {`${propertyItem?.location?.name}`}
            </PropertyAddressDetails>
            <PropertyDescriptionHeader>Description</PropertyDescriptionHeader>
            <PropertyDescription>
              {`${propertyItem?.description}`}
            </PropertyDescription>
          </PropertyDetails>
        </Card>
        {propertyItem?.agent && (
          <CustomAgentCard agent={propertyItem.agent} hideDelete />
        )}
      </Row>
    </Container>
  );
};
